module.exports = __webpack_public_path__ + "static/media/Suzanne Gratch.33e07864.png";